/**
 * Public, non-secret console configuration that may be committed (ADR 0020).
 * Build-time env variables win over the committed defaults below.
 */
export const PUBLIC_DEFAULTS = {
  /**
   * Cloudflare Turnstile SITE key (public by design; the secret key lives only in Supabase Auth).
   * Empty = no CAPTCHA widget on the sign-in forms. Usually set via GitHub Variables TURNSTILE_SITE_KEY.
   */
  turnstileSiteKey: "",
  /**
   * Login hero photo. Hotlinked from Expartise's own website for now.
   * TODO(ADR 0020): self-host under apps/web/public/brand/ and point this to "/brand/<file>".
   */
  loginHeroImage: "https://expartisemakine.com/wp-content/uploads/2023/04/slide4.jpg",
} as const;

/** Turnstile site key: VITE_TURNSTILE_SITE_KEY, else the committed default; "" disables the widget. */
export function turnstileSiteKey(env: { VITE_TURNSTILE_SITE_KEY?: string } = import.meta.env): string {
  return (env.VITE_TURNSTILE_SITE_KEY ?? "").trim() || PUBLIC_DEFAULTS.turnstileSiteKey;
}

export const LOGIN_HERO_IMAGE: string = PUBLIC_DEFAULTS.loginHeroImage;
